import Link from 'found/Link';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  Collapse, Container, Nav, Navbar, NavbarToggler,
} from 'reactstrap';
import styled from 'styled-components';

import NavigationLogo from 'src/components/Navigation/NavigationLogo';

const RightNav = styled(Nav).attrs({
  className: 'ms-auto',
})``;

/**
 * Shared navigation shell for simple top-level navigation variants.
 * @param {object} props - Component props.
 * @param {React.ReactNode} props.children - Right-side navigation items.
 * @param {object|null} props.cobrand - Cobrand configuration.
 * @param {object} props.primaryBrand - Primary brand configuration.
 * @returns {React.ReactComponentElement} BareNavigation component.
 */
function BareNavigation({ children = null, cobrand = null, primaryBrand = undefined }) {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <Navbar light expand="lg">
      <Container className="d-flex flex-wrap justify-content-between px-0 px-sm-3">
        <Link to="/" className="navbar-brand">
          <NavigationLogo cobrand={cobrand} primaryBrand={primaryBrand} />
        </Link>
        <NavbarToggler onClick={() => setNavbarOpen(!navbarOpen)} />
        <Collapse isOpen={navbarOpen} navbar>
          <RightNav navbar>
            {children}
          </RightNav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

BareNavigation.propTypes = {
  children: PropTypes.node,
  cobrand: PropTypes.oneOfType([
    PropTypes.shape({
      imagePath: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
    PropTypes.oneOf([null]),
  ]),
  primaryBrand: PropTypes.shape({
    imagePath: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export default BareNavigation;
